import { render, staticRenderFns } from "./contact-me.vue?vue&type=template&id=3327d89a&scoped=true&"
import script from "./contact-me.vue?vue&type=script&lang=js&"
export * from "./contact-me.vue?vue&type=script&lang=js&"
import style0 from "./contact-me.vue?vue&type=style&index=0&id=3327d89a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3327d89a",
  null
  
)

export default component.exports